import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { DemandDefinitionAccessGuard } from '../demand-definition/components/DemandDefinitionAccessGuard';

const demandDefinitionsSearchSchema = z.object({
    customerGroupId: z.string().optional(),
});

export const Route = createFileRoute('/_app/demand-definitions')({
    component: DemandDefinitionAccessGuard,
    validateSearch: zodSearchValidator(demandDefinitionsSearchSchema),
});
